<template>
  <div class="card-group">
    <div
      class="card farm-card shadow-sm"
      @click="this.$router.push({ name: 'farm', params: { id: id } })"
    >
      <div class="card-body">
        <h4 class="card-header rounded-pill text-center">
          {{ name }}
        </h4>
        <div class="d-flex my-2 mx-1" @click.stop>
          <p class="flex-grow-1 ms-0 my-1">
            Schedule: {{ activeSchedule.name }}
          </p>
          <button
            type="button"
            class="btn btn-primary btn-sm shadow-none"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapseExample-' + id"
            :disabled="this.$store.getters.accountPrivilege === 'basic'"
          >
            <svg style="fill: white" width="16" height="16" viewBox="0 0 16 16">
              <path
                d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"
              />
            </svg>
          </button>
        </div>
        <!---------------- CONFIGURE SCHEDULE COLLAPSE ---------------->
        <div class="collapse" :id="'collapseExample-' + id">
          <div class="card" @click.stop>
            <div class="card-header d-flex p-1">
              <h6 class="flex-grow-1 my-auto ms-1">Configure schedule</h6>
              <button
                type="button"
                class="btn-close btn-sm"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapseExample-' + id"
                @click.stop
              ></button>
            </div>
            <div class="card-body p-1">
              <fieldset
                class="
                  form-floating
                  d-flex
                  justify-content-around
                  flex-wrap
                  m-2
                  p-1
                "
                :disabled="!haveSchedules"
              >
                <div class="form-floating flex-grow-1 my-auto">
                  <select class="me-1" :id="'scheduleSelectElement-' + id">
                    <option
                      v-for="(schedule, schedule_id) of this.$store.getters
                        .farms?.[id]?.schedules ?? {}"
                      :key="schedule_id"
                      :value="schedule_id"
                      :selected="schedule_id === activeSchedule.id"
                    >
                      {{ schedule.name }}
                    </option>
                  </select>
                </div>
                <div class="form-check form-switch d-flex my-auto">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'scheduleEnableElement-' + id"
                    :checked="activeSchedule.enable"
                  />
                  <label
                    class="form-check-label mx-2"
                    for="scheduleEnableElement"
                    >Enable</label
                  >
                </div>
                <button
                  type="button"
                  class="btn btn-primary btn-sm shadow-none my-1 ms-3"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapseExample-' + id"
                  @click.stop="onDeploySchedule"
                >
                  Deploy
                </button>
              </fieldset>
            </div>
          </div>
        </div>
        <enduser-card
          v-for="(enduser, enduser_id) in this.$store.getters.farms?.[id]
            ?.endusers ?? {}"
          :key="enduser_id"
          :name="enduser.name"
          :id="enduser_id"
          :timestamp="enduser.timestamp"
          :farm_id="id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import EnduserCard from "@/components/EnduserCard.vue";

export default {
  name: "FarmCard",

  components: { EnduserCard },

  props: {
    id: String,
    name: String,
  },

  setup(props) {
    const store = useStore();

    const haveSchedules = computed(() => {
      return Object.keys(store.getters.farms[props.id].schedules).length > 0;
    });

    const activeSchedule = computed(() => {
      const active = store.getters.farms[props.id]?.schedule_id;
      // use the first enduser to determine the enable state of the active
      // schedule. Later, it is possible that endusers may be enabled
      // separately.
      const endusers = store.getters.farms?.[props.id]?.endusers;
      const enable = endusers
        ? Object.values(endusers)[0].schedule_enabled
        : true;
      return active
        ? {
            id: active,
            name: store.getters.farms[props.id]?.schedules[active]?.name,
            enable: enable,
          }
        : { id: null, name: "<None>", enable: true };
    });

    const onDeploySchedule = async () => {
      const scheduleSelect = document.getElementById(
        "scheduleSelectElement-" + props.id
      );
      const scheduleId = scheduleSelect.value;

      const scheduleEnable = document.getElementById(
        "scheduleEnableElement-" + props.id
      );
      const enable = scheduleEnable.checked;

      await store.dispatch("setActiveSchedule", {
        farmId: props.id,
        scheduleId: scheduleId,
        scheduleDirty: false,
      });

      // enduser schedules are deployed together for now. In future, there may
      // be the capability to deploy enduser schedules separately, from the
      // enduser card in the UI.
      for (const key of Object.keys(store.getters.farms[props.id].endusers)) {
        await store
          .dispatch("deployEnduserSchedule", {
            farmId: props.id,
            farmName: props.name,
            enduserId: key,
            scheduleId: scheduleId,
            enable: enable,
          })
          .then((scheduleFile) => console.log(scheduleFile));
      }
    };

    return {
      haveSchedules,
      activeSchedule,
      onDeploySchedule,
    };
  },
};
</script>

<style scoped>
.farm-card {
  transition: 0.3s;
}

.farm-card:hover {
  box-shadow: 8px 8px 8px blue;
  transform: translate(0%, -1%);
}
</style>
